
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.581","height":"17.581","viewBox":"0 0 17.581 17.581"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#bac1cc"}},[_c('path',{attrs:{"d":"M13.585 0H4a4 4 0 00-4 4v6.393A4 4 0 003.2 14.3v2.478a.8.8 0 001.243.665l4.593-3.062h4.553a4 4 0 004-4V4a4 4 0 00-4.004-4zM8.347 12.92l-3.552 2.368v-1.7a.8.8 0 00-.8-.8 2.4 2.4 0 01-2.4-2.4V4A2.4 2.4 0 014 1.6h9.589a2.4 2.4 0 012.4 2.4v6.393a2.4 2.4 0 01-2.4 2.4H8.79a.781.781 0 00-.444.134z"}}),_c('path',{attrs:{"d":"M13.584 4.795H3.996a.8.8 0 000 1.6h9.589a.8.8 0 100-1.6zM11.987 7.991H5.595a.8.8 0 100 1.6h6.393a.8.8 0 000-1.6z"}})])])
          )
        }
      }
    